<template>
  <v-flex class="py-3 px-3" xs12 sm11 lg10>
    <v-card class="elevation-2">
      <transition name="fade" mode="out-in" appear>
        <div v-if="loading" class="py-5 text-xs-center"><div class="my-5 py-5"><div class="my-5 py-5">
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </div></div></div>
        <router-view v-else></router-view>
      </transition>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  data: () => ({
    loading: true
  }),
  mounted () {
    this.load()
  },
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) {
        if (this.$store.getters.user.type.toLowerCase() === 'admin') {
          if (this.$store.getters.coursesModuleLoaded) this.loading = false
          else {
            this.$store.dispatch('loadCourses').then(() => {
              this.loading = false
            })
          }
        } else {
          appMsg.msg = 'You are not allowed to view that page'
          this.$store.dispatch('showAppMsg', appMsg)
          this.$router.push('/')
        }
      } else {
        appMsg.msg = 'Please sign in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/sign-in')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/Courses.vue